import { useTranslation } from "react-i18next";
import dompurify from "dompurify";
import Button from "../../components/shared/button/component";
import FacebookLogin from "react-facebook-login";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { getFacebookClientId } from "../../utils/general-config";

const RBSignUp = ({
  onSignUp,
  navigateSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  emailError,
  errorCount,
  emailErrorMsg,
  passwordError,
  passwordErrorMsg,
  loginError,
  loginErrorMessage,
  onEmailChangeHandler,
  onPwdChangeHandler,
  onPasswordKeyPress,
  emailId,
  pwd,
}) => {
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_up.rb.description_meta")} />
        <title>{t("page_title.sign_up")}</title>
      </Helmet>
      <section className="main-content">
        <div className="container mx-auto">
          <div className="form-wrap"></div>
          <hgroup className="text-center user-page">
            <h1
              className="main-headline  font-bold uppercase text-2xl md:text-xl lg:text-xl"
              style={{ fontFamily: '"Rubik", sans-serif' }}
            >
              {t("sign_up.headline")}
            </h1>
            <h6 className="rb_sub-headline mb-2 font-medium text-xl md:text-base lg:text-base ">
              {t("sign_up.sub_headline")}
            </h6>
            <p className="sub-paragraph mb-8 text-base md:text-xs lg:text-xs">{t("sign_up.content")}</p>
          </hgroup>
          <div className="social-login ">
            <div className="social-login--facebook">
              <FacebookLogin
                appId={getFacebookClientId()}
                autoLoad={false}
                fields="name,email"
                textButton={t("sign_up.continue_with_fb")}
                callback={responseFacebook}
                icon={
                  <img
                    src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                    className="facebook-login-button"
                    id="fbBtn"
                  />
                }
              />
            </div>
            <div className="social-login--google">
              <button type="button" id="googleBtn" className="google-login-button text-white" onClick={googleLogin}>
                <div className="bg-white m-px rounded-sm">
                  <img src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"} />
                </div>
                <span>{t("sign_up.continue_with_google")}</span>
              </button>
            </div>
          </div>
          <div className="or-container">
            <span></span> {t("sign_up.or")} <span></span>
          </div>
          <div className="form-container">
            <div className="form-group">
              <div className="form-text mb-2">
                {emailError && (
                  <p
                    key="pswrdErr"
                    role={alert}
                    className="alert error signup-error-message border bg-orange-50 border-orange-500 text-[#fe8c26] px-2 py-1"
                  >
                    <h2> {errorCount + t("sign_up.signup_alert_text")}</h2>
                    <br />
                    {emailError && (
                      <li>
                        <small key="pswrdErr">{emailErrorMsg}</small>
                      </li>
                    )}

                    {passwordError && (
                      <li>
                        <small key="pswrdErrw">{passwordErrorMsg}</small>
                      </li>
                    )}

                    {loginError && (
                      <li>
                        <small key="pswrdErrww">{loginErrorMessage}</small>
                      </li>
                    )}
                  </p>
                )}
              </div>
              <InputText
                showLabel={false}
                id="email"
                text="Email Address"
                onChange={onEmailChangeHandler}
                value={emailId.trim()}
                maxLength={100}
                className="border border-gray-300 rounded-sm px-3 py-2 md:py-1 lg:py-1 border mb-2"
                placeholder={t("sign_up.placeholder_email")}
              />
            </div>

            <div className="form-group">
              <InputText
                showLabel={false}
                id="password"
                text="Password"
                type="password"
                className="border border-gray-300 rounded-sm px-3 py-2 md:py-1 lg:py-1  border mb-2"
                onChange={onPwdChangeHandler}
                value={pwd}
                onKeyPress={onPasswordKeyPress}
                placeholder={t("sign_up.placeholder_password")}
              />
            </div>
            <div className="form-text">
              {emailError && (
                <small key="pswrdErr" className="text-red-500 font-sm">
                  {emailErrorMsg}
                </small>
              )}
            </div>
            <div className="form-text">
              {passwordError && (
                <small key="pswrdErr" className="text-red-500 font-sm">
                  {passwordErrorMsg}
                </small>
              )}
            </div>

            <div className="form-text">
              {loginError && (
                <small key="pswrdErr" className="text-red-500 font-sm">
                  {loginErrorMessage}
                </small>
              )}
            </div>
            <div className="small text-xs p-2 md:p-0 lg:p-0 term-condition">
              <p
                className="mb-4"
                dangerouslySetInnerHTML={{
                  __html: sanitizer(t("sign_up.agree")),
                }}
              />
            </div>
            <div className="mb-3">
              <div className=" fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2.5 md:p-0 lg:p-0 text-center w-full z-50">
                <Button
                  isLoading={false}
                  disabled={disableBtn}
                  onClick={onSignUp}
                  className={`bg-[#fe8c26] hover:bg-[#f07201] transition-all duration-400 ease-out delay-100 text-white uppercase rounded font-semibold py-3 w-full ${
                    disableBtn ? "" : "active:bg-blue-500"
                  }`}
                  ctaText={t("sign_up.btn_cta")}
                />
              </div>
              <div className="form-container--footer text-center">
                <p className="small text-xs ">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: sanitizer(t("sign_up.already_account")),
                    }}
                  />
                  <Button
                    isLoading={false}
                    disabled={disableBtn}
                    onClick={navigateSignIn}
                    className="text-[#2ebe6e] hover:text-blue-500"
                    ctaText={t("sign_up.sign_in")}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RBSignUp;
